import { defineMessages } from 'react-intl';

export default defineMessages({
    generalCoverages: {
        id: 'quoteandbind.SpaAndWelProduct.views.coverages.GeneralCoverages',
        defaultMessage: 'General Coverages',
    },
    addlInt: {
        id: 'quoteandbind.SpaAndWelProduct.views.coverages.Additional Interests',
        defaultMessage: 'Additional Interests',
    },
    // add string ids and default values for localization here
});
